import type { SessionRow } from '../data/db';
import { dateTime, duration, modeLabel, percent, plural, tilesLabel } from './format';
import { Hint, PrimaryButton, Screen, Title } from './kit';

interface Props {
  sessions: SessionRow[];
  onStart: () => void;
  onBack: () => void;
}

export function HistoryScreen({ sessions, onStart, onBack }: Props) {
  return (
    <Screen>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          aria-label="Назад"
          className="size-11 flex-none rounded-full bg-card text-[1.1rem] text-muted"
        >
          ←
        </button>
        <Title>История</Title>
      </div>

      {/* Пустое состояние по разделу 6.4: объясняет и ведёт к тренировке. */}
      {sessions.length === 0 ? (
        <>
          <Hint>
            Здесь появится история тренировок: когда занимался, сколько заданий и с какой
            точностью. Пока ни одной завершённой тренировки нет.
          </Hint>
          <PrimaryButton bottom onClick={onStart}>
            Выбрать таблицы
          </PrimaryButton>
        </>
      ) : (
        <ul className="m-0 grid list-none gap-2 p-0">
          {sessions.map((session) => (
            <li key={session.id} className="grid gap-1 rounded-xl border border-line bg-card p-3">
              <div className="flex items-baseline gap-2">
                <span className="font-semibold">{dateTime(session.startedAt)}</span>
                <span className="ml-auto text-[1.05rem] font-semibold tabular-nums">
                  {percent(session.accuracy)}
                </span>
              </div>
              <span className="text-[0.85rem] text-muted">
                {tilesLabel(session.tiles)} · {modeLabel(session.mode)}
              </span>
              <span className="text-[0.85rem] text-muted tabular-nums">
                {session.taskCount} {plural(session.taskCount, 'задание', 'задания', 'заданий')}{' '}
                · {session.wrongAttempts}{' '}
                {plural(session.wrongAttempts, 'ошибка', 'ошибки', 'ошибок')} ·{' '}
                {duration(session.wallClockMs)}
              </span>
              {/* Повторение помечено: иначе короткая сессия из трёх заданий
                  выглядит как оборванная тренировка. */}
              {session.sourceSessionId !== null && (
                <span className="justify-self-start rounded-md bg-accent-soft px-2 py-0.5 text-[0.8rem] font-semibold text-accent">
                  работа над ошибками
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </Screen>
  );
}
